<template>
    <div id="app">
      <router-view />
    </div>
</template>

<script type="text/babel">
import { mapGetters } from 'vuex'
import { name_verify_route } from './config/state'
import { getAuthStatus, initUnVerifiedRouter, getUserInfo } from './api'
import { is } from 'common-js/util/env'

export default {
  name: 'name-auth',
  data () {
    return {
      type: 1,
    }
  },
  computed: {
    ...mapGetters(['realnameVerifyStatus', 'unVerified', 'verifyData', 'getNameInfo', 'getHasRealName'])
  },
  async created () {
    if (this.$route.params.needFresh) {
      await getUserInfo(this)
      getAuthStatus(this)
    }
  },
  mounted () {},
  watch: {
    'realnameVerifyStatus': {
      async handler (newVal, old) {
        if (old !== newVal) {
          // const newConflictShow = await conflictApolloInfo()
          let routerName = name_verify_route[newVal]
          // 兼容存量数据
          // const identity_cards = this.unVerified && this.unVerified.identity_cards
          // role：1 角色为乘客，且角色列表长度为1就说明存量数据已经实名过，需要直接跳转到成功页面
          // const passengerIsRealName = identity_cards && identity_cards.some((item) => item.role === 1 && item.tag && item.tag.length === 1)
          // let passengerIsRealName = identity_cards && identity_cards.some((item) => item.role === 1 && item.tag && item.tag.length === 1)
          // const currentRoleIsPassenger = identity_cards && identity_cards.some((item) => item.current && item.role === 1)
          const has_conflict = this.unVerified && this.unVerified.has_conflict
          // const {status} = this.verifyData || {}
          // sendOmega(name_auth_omega_summary['pub_trinity_show_conflict_sw'], {
          //   has_conflict,
          //   state: newConflictShow ? 'new' : 'old',
          //   status,
          // })
          // if (newConflictShow) {
          //   passengerIsRealName = currentRoleIsPassenger && !has_conflict
          // }
          const passengerHasNotConflict = is.passenger && !has_conflict
          const passengerIsRealName = this.getHasRealName && passengerHasNotConflict
          // const  passengerIsRealName = currentRoleIsPassenger && !has_conflict
          if (passengerIsRealName) {
            this.$router.replace({name: 'index'})
            return false
          }

          // if (is.passenger && passengerIsRealName) {
          //   this.$router.replace({name: 'index'})
          //   return false
          // }
          // 未进行实名认证
          // 老逻辑，未实名，并且没有unVerified字段    或者 新逻辑中 unVerified 也可能有部分是非passport实名，需要进行实名，在乘客端并且无冲突
          if ((newVal === 0 && !this.unVerified) || passengerHasNotConflict) {
            console.log('未实名')
            // routerName = 'MesVerify'
            initUnVerifiedRouter(this)
            return
          }
          routerName && this.$router.replace({name: routerName})
        }
      },
      deep: true
    }
  },
}
</script>
<style lang="scss">
@import '~common-css/common.scss';
div,a,img {
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select:none;
}
#app {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
}
html {
  font-size: 16px !important;
}
</style>
